import { Box, LinearProgress, Paper, Skeleton, Stack, Typography } from '@mui/material';

const CycleCoverageByBranchGrid = ({ data = [], loading }) => {
  if (!loading && !data.length) return null;

  return (
    <Paper elevation={2} sx={{ p: 2, mt: 2 }}>
      <Typography variant="subtitle1" gutterBottom>📋 Cobertura del ciclo de conteo de stock por sucursal</Typography>
      {loading ? (
        <Skeleton variant="rectangular" height={120} />
      ) : (
        <Stack spacing={2} sx={{ mt: 1 }}>
          {data.map((branch) => (
            <Box key={branch.locationId}>
              <Stack direction="row" justifyContent="space-between" sx={{ mb: 0.5 }}>
                <Typography variant="body2">{branch.locationName}</Typography>
                <Typography variant="body2" color="text.secondary">
                  {branch.coveredInCycle} / {branch.universeSize} ({branch.coveragePercent.toFixed(0)}%)
                </Typography>
              </Stack>
              <LinearProgress
                variant="determinate"
                value={Math.min(branch.coveragePercent, 100)}
                sx={{ height: 8, borderRadius: 4 }}
              />
            </Box>
          ))}
        </Stack>
      )}
    </Paper>
  );
};

export default CycleCoverageByBranchGrid;
